import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8081";
export const baseURL = "https://backend.acrosstour.tech";
// export const baseURL = "https://acrosstours-backend.siglonet.com";
// export const baseURL = "https://test-backend.acrosstour.tech";
const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
